<template>
  <ENewPersonalCounter
    v-if="showNew"
    :should-increment="shouldIncrement"
    :redirect-to-user-impact="shouldRedirectToUserImpact"
    data-test-id="personal-counter-new"
  />
  <EOldPersonalCounter
    v-else
    data-test-id="personal-counter"
    :redirect-to-user-impact="shouldRedirectToUserImpact"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { NEW_PERSONAL_COUNTER } from 'common-js/constants/feature-flags';

import ENewPersonalCounter from './new';
import EOldPersonalCounter from './old';

const allowedAppVersion = '8.2.0';

export default {
  name: 'EPersonalCounter',
  components: {
    ENewPersonalCounter,
    EOldPersonalCounter,
  },
  props: {
    shouldIncrement: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', ['isEcosiaApp', 'browser', 'browserVersion']),
    ...mapGetters('goodall', ['getExperiment']),
    showNew() {
      return this.getExperiment(NEW_PERSONAL_COUNTER.flag)?.includes(NEW_PERSONAL_COUNTER.enabled);
    },
    shouldRedirectToUserImpact() {
      // allow redirection on only index page and search page
      const allowedPages = this?.$route?.path === '/search' || this?.$route?.path === '/';
      return this.isEcosiaApp && this.browser.includes('ios') && this.browserVersion >= allowedAppVersion && allowedPages;
    },
  },
};
</script>
